// extracted by mini-css-extract-plugin
export default {"subtitulo":"ReaccionCrearScreen_subtitulo__bDYKJ","boton":"ReaccionCrearScreen_boton__icakk","acordion":"ReaccionCrearScreen_acordion__mwMGa"};